<template>
  <div>
    <div class='card blue-grey'>
      <div class='card-content white-text'>
        <span class='card-title'>Скоро</span>
        <p>Данный фукнционал находится в разработке</p>
      </div>
    </div>
  </div>
</template>

<script>
// import Loader from '@/components/loader';
// import PageHeader from '@/components/page_header';

export default {
  name: 'SettingsSubscription',
  components: {
    // Loader,
  },
  props: {},
  data: () => ({
    // NOTE: Remove isLoading
    isLoading: false
  }),
  computed: {
  },
  methods: {
  }
};
</script>

<style scoped lang='sass'>
</style>
